import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Markdown from 'react-markdown';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import ReactSelect from '../../../../../components/ReactSelect';
import { AI_TOOLS } from '../../../configs';
import { showPlatform } from '../../../PromptManager/keys';

class ReactSwiper extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.handleSelectDate = this.handleSelectDate.bind(this);
        this.handleSelectPlatform = this.handleSelectPlatform.bind(this);

        this.swiperRef = React.createRef();
        this.state = {
            view: 'raw_response',
            selectedDate: null,
            selectedPlatform: null,
            sortedValues: props.responses || [],
        };
    }

    onClick(id) {
        return this.setState({
            view: id,
        });
    }

    handleSelectDate(value) {
        this.setState({
            selectedDate: value,
            sortedValues: this.props.responses.filter(
                (item) =>
                    (value ? moment(item.created_at).format('YYYY-MM-DD') === value : true) &&
                    (this.state.selectedPlatform
                        ? item.platform === this.state.selectedPlatform
                        : true),
            ),
        });
        this.swiperRef?.current?.slideTo(0);
    }

    handleSelectPlatform(value) {
        this.setState({
            selectedPlatform: value,
            sortedValues: this.props.responses.filter(
                (item) =>
                    (value ? item.platform === value : true) &&
                    (this.state.selectedDate
                        ? moment(item.created_at).format('YYYY-MM-DD') === this.state.selectedDate
                        : true),
            ),
        });
        this.swiperRef?.current?.slideTo(0);
    }

    addActive(id) {
        return this.state.view === id;
    }

    render() {
        const { t } = this.props;

        const datesOptions =
            this.props.responses
                ?.map((item) => {
                    return {
                        label: moment(item.created_at).format('YYYY-MM-DD'),
                        value: moment(item.created_at).format('YYYY-MM-DD'),
                    };
                })
                .filter(
                    (item, index, self) => index === self.findIndex((t) => t.value === item.value),
                ) || [];
        datesOptions.unshift({
            label: t('ai_tracking.keyword_detail.responses.all_dates'),
            value: null,
        });

        const platformsOptions =
            this.props.responses
                ?.map((item) => {
                    return {
                        label: item.platform,
                        value: item.platform,
                    };
                })
                .filter(
                    (item, index, self) => index === self.findIndex((t) => t.value === item.value),
                ) || [];
        platformsOptions.unshift({
            label: t('ai_tracking.keyword_detail.responses.all_platforms'),
            value: null,
        });

        const tags = (t) => [
            { id: 'raw_response', label: t('ai_tracking.keyword_detail.responses.raw_response') },
            {
                id: 'crawled_html_file',
                label: t('ai_tracking.keyword_detail.responses.crawled_html_file'),
            },
        ];

        return (
            <div className="ai-tracking-swiper">
                <div className="d-flex align-items-center justify-content-end mb-20 gap-20">
                    <ReactSelect
                        options={datesOptions}
                        value={datesOptions.find(
                            (option) => option.value === this.state.selectedDate,
                        )}
                        onChange={this.handleSelectDate}
                        label={t('ai_tracking.keyword_detail.responses.selectDate')}
                        classname="mr-0 w-100"
                        isSearchable
                        blurInputOnSelect={true}
                        disabled={this.state.loader}
                    />
                    <ReactSelect
                        options={platformsOptions}
                        value={platformsOptions.find(
                            (option) => option.value === this.state.selectedPlatform,
                        )}
                        onChange={this.handleSelectPlatform}
                        label={t('ai_tracking.keyword_detail.responses.selectPlatform')}
                        classname="mr-0 w-100"
                        isSearchable
                        blurInputOnSelect={true}
                        disabled={this.state.loader}
                    />
                </div>
                <Swiper
                    modules={[Navigation, Pagination, A11y]}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    scrollbar={{ draggable: true }}
                    onSwiper={(swiper) => (this.swiperRef.current = swiper)}
                >
                    {this.state.sortedValues?.length === 0 && (
                        <div className="no-response">
                            {t('ai_tracking.keyword_detail.responses.no_data')}
                        </div>
                    )}
                    {this.state.sortedValues?.map((response, i) => (
                        <SwiperSlide key={response.created_at} className="ai-tracking-slide">
                            <div>
                                <div className="d-flex gap-8 align-items-center mb-20">
                                    <strong className="d-block">
                                        {t('ai_tracking.keyword_detail.responses.created_at')}:{' '}
                                        {moment(response?.created_at).format('YYYY-MM-DD')}
                                    </strong>{' '}
                                    |
                                    <strong className="d-flex gap-8 align-items-center">
                                        Platform:{' '}
                                        {response?.platform ? (
                                            <div
                                                key={response?.platform}
                                                title={AI_TOOLS[response?.platform]}
                                                className="ai-tracking-platform-2 big no-clickable"
                                            >
                                                {showPlatform(response?.platform)}
                                                {AI_TOOLS[response?.platform]}
                                            </div>
                                        ) : (
                                            'N/A'
                                        )}
                                    </strong>{' '}
                                    <div className="d-flex gap-4 ml-auto">
                                        <button
                                            className="swiper-nav-btn"
                                            onClick={() => this.swiperRef.current?.slidePrev()}
                                            disabled={
                                                this.state.sortedValues?.length === 0 || i === 0
                                            }
                                        >
                                            <i className="icon-arrow-left" />
                                        </button>
                                        <button
                                            className="swiper-nav-btn"
                                            onClick={() => this.swiperRef.current?.slideNext()}
                                            disabled={
                                                this.state.sortedValues?.length === 0 ||
                                                i === this.state.sortedValues?.length - 1
                                            }
                                        >
                                            <i className="icon-arrow-right" />
                                        </button>
                                    </div>
                                </div>

                                <div className="tags-container">
                                    {tags(t).map((tag) => (
                                        <span
                                            className={`tab-item ${
                                                this.addActive(tag.id) && 'active-tag'
                                            }`}
                                            key={tag.id}
                                            onClick={() => this.onClick(tag.id)}
                                        >
                                            {tag.label}
                                        </span>
                                    ))}
                                </div>
                                {this.state.view === 'raw_response' &&
                                    (response?.md_response_file ? (
                                        <iframe
                                            className="slidere-iframe"
                                            sandbox="allow-scripts allow-forms"
                                            src={response.md_response_file}
                                        ></iframe>
                                    ) : (
                                        <div className="no-response">
                                            {t('ai_tracking.keyword_detail.responses.no_data')}
                                        </div>
                                    ))}

                                {this.state.view === 'crawled_html_file' &&
                                    (response?.crawled_html_file || response?.html_response_file ? (
                                        <iframe
                                            className="slidere-iframe"
                                            sandbox="allow-scripts allow-forms"
                                            src={
                                                response.crawled_html_file ||
                                                response.html_response_file
                                            }
                                        ></iframe>
                                    ) : (
                                        <div className="no-response">
                                            {t('ai_tracking.keyword_detail.responses.no_data')}
                                        </div>
                                    ))}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        );
    }
}

export default withTranslation()(ReactSwiper);
